module.exports = __webpack_public_path__ + "img/icon--profile--white.d4b07dcb.svg";